import React, { useState } from "react";
import { UiKit } from "@datavant/uikit";
import { FormKit } from "@/formkit";
import { RecordHubPageFooter } from "@/components/SmartRequest/RecordHubPageContainer";
import Link from "next/link";
const stringHackBolderTitle = (title) => {
    // workaround to make the font larger/bolder and still use formkit
    // formkit titles only allow things of the type string
    return (<span style={{ fontWeight: "700" }}>{title}</span>);
};
const needAssistance = (<UiKit.Text.BodyLarge>
    {`If you need further assistance, please contact support by using the Live Chat feature or calling directly at 
1-800-367-1500.`}
  </UiKit.Text.BodyLarge>);
const titleSection = FormKit.UnboxedSection({
    Component: () => (<UiKit.Chakra.VStack spacing={UiKit.consistency.buffer} align={"left"} marginTop={UiKit.consistency.buffer}>
      <UiKit.Text.Heading1 text="Frequently Asked Questions (FAQs)"/>
    </UiKit.Chakra.VStack>),
});
const question1 = FormKit.BoxedSection({
    title: stringHackBolderTitle("Why does the login page look different?"),
    Component: () => (<UiKit.Chakra.VStack spacing={UiKit.consistency.buffer} align={"left"}>
      <UiKit.Text.BodyLarge>
        {`The new login page is part of an ongoing effort to improve the overall user login experience of 
                    the system.`}
      </UiKit.Text.BodyLarge>
    </UiKit.Chakra.VStack>),
    allowCollapse: true,
    initiallyCollapse: true,
});
const question2 = FormKit.BoxedSection({
    title: stringHackBolderTitle("How can I reset my password?"),
    Component: () => {
        const videoLinkShare = "https://www.loom.com/share/368762102aa94e01a44a730315d2d205?sid=a753e949-eee9-4bd7-aa09-41e81d8ae5f6";
        // need to use the embed link for the iframe to work
        const videoLinkEmbed = "https://www.loom.com/embed/368762102aa94e01a44a730315d2d205?sid=a753e949-eee9-4bd7-aa09-41e81d8ae5f6";
        const [iframeError, setIframeError] = useState(false);
        const handleIframeError = () => {
            setIframeError(true);
        };
        const handleIframeLoad = () => {
            setIframeError(false);
        };
        return (<UiKit.Chakra.VStack spacing={UiKit.consistency.buffer} align={"left"}>
        <UiKit.Text.BodyLarge>
          {`The new login page allows you to reset your password without contacting support. To do this, 
                    click the "Need help signing in?" link below the email field followed by the "Forgot password?" 
                    link and follow the instructions provided.`}
        </UiKit.Text.BodyLarge>
        <UiKit.Text.BodyLarge>
          {!iframeError && (<iframe src={videoLinkEmbed} width="640" height="360" allowFullScreen onError={handleIframeError} onLoad={handleIframeLoad}></iframe>)}
          <a href={videoLinkShare} target="_blank" rel="noreferrer" style={{
                color: UiKit.consistency.brandColors.primaryButton.background,
                textDecoration: "underline",
            }}>
            Reset Password Video Guide
          </a>
        </UiKit.Text.BodyLarge>
        {needAssistance}
      </UiKit.Chakra.VStack>);
    },
    allowCollapse: true,
    initiallyCollapse: true,
});
const question3 = FormKit.BoxedSection({
    title: stringHackBolderTitle("How can I view my previously saved login information?"),
    Component: () => (<UiKit.Chakra.VStack spacing={UiKit.consistency.buffer} align={"left"}>
      <UiKit.Text.BodyLarge>
        {`If you previously saved your email and/or password for Smart Request, you may need to re-enter 
                 it the first time you use the new login page.`}
      </UiKit.Text.BodyLarge>
      <UiKit.Text.BodyLarge>
        {`To find your saved login information, you can check your browser's saved passwords or password 
                  manager and look up what information you saved for Smart Request.`}
      </UiKit.Text.BodyLarge>
      <UiKit.Text.BodyLarge>
        {`The following links will take you to the support pages with instructions for how to view 
                  saved passwords in the most common internet browsers:`}
      </UiKit.Text.BodyLarge>
      <UiKit.Chakra.VStack spacing={UiKit.consistency.buffer} align={"left"} marginLeft={UiKit.consistency.largeBuffer}>
        <ul>
          <li>
            <UiKit.Text.BodyLarge>
              <a href={"https://support.google.com/chrome/answer/95606?hl=en&" +
            "co=GENIE.Platform%3DDesktop"} target="_blank" rel="noreferrer" style={{
            color: UiKit.consistency.brandColors.primaryButton.background,
            textDecoration: "underline",
        }}>
                Chrome
              </a>
            </UiKit.Text.BodyLarge>
          </li>
          <li>
            <UiKit.Text.BodyLarge>
              <a href="https://support.mozilla.org/en-US/kb/manage-saved-login-information" target="_blank" rel="noreferrer" style={{
            color: UiKit.consistency.brandColors.primaryButton.background,
            textDecoration: "underline",
        }}>
                Firefox
              </a>
            </UiKit.Text.BodyLarge>
          </li>
          <li>
            <UiKit.Text.BodyLarge>
              <a href="https://support.apple.com/en-us/105115" target="_blank" rel="noreferrer" style={{
            color: UiKit.consistency.brandColors.primaryButton.background,
            textDecoration: "underline",
        }}>
                Safari
              </a>
            </UiKit.Text.BodyLarge>
          </li>
          <li>
            <UiKit.Text.BodyLarge>
              <a href={"https://support.microsoft.com/en-us/microsoft-edge/save-or-forget-passwords-in-" +
            "microsoft-edge-b4beecb0-f2a8-1ca0-f26f-9ec247a3f336"} target="_blank" rel="noreferrer" style={{
            color: UiKit.consistency.brandColors.primaryButton.background,
            textDecoration: "underline",
        }}>
                Edge
              </a>
            </UiKit.Text.BodyLarge>
          </li>
        </ul>
      </UiKit.Chakra.VStack>
      {needAssistance}
    </UiKit.Chakra.VStack>),
    allowCollapse: true,
    initiallyCollapse: true,
});
const question4 = FormKit.BoxedSection({
    title: stringHackBolderTitle("Can I still use the old login page if the new one isn't working for me?"),
    Component: () => (<UiKit.Chakra.VStack spacing={UiKit.consistency.buffer} align={"left"}>
      <UiKit.Text.BodyLarge>
        {`It's possible the new login page does not work because you've entered your password 
                incorrectly too many times. 
                If this is the case, you can try to log in using the old login page.`}
      </UiKit.Text.BodyLarge>
      <UiKit.Text.BodyLarge>
        {"Temporary access to the old login page is available if you click "}
        <Link href="/open/legacy-login" style={{
            color: UiKit.consistency.brandColors.primaryButton.background,
            textDecoration: "underline",
        }}>
          here
        </Link>
        {" and enter your username and password as before."}
      </UiKit.Text.BodyLarge>
      <UiKit.Text.BodyLarge>
        If one or both of the login pages is not working, your account may be
        locked. Please see the next question for more information on this.
      </UiKit.Text.BodyLarge>
    </UiKit.Chakra.VStack>),
    allowCollapse: true,
    initiallyCollapse: true,
});
const question5 = FormKit.BoxedSection({
    title: stringHackBolderTitle("What do I do if my account gets locked?"),
    Component: () => (<UiKit.Chakra.VStack spacing={UiKit.consistency.buffer} align={"left"}>
      <UiKit.Text.BodyLarge>
        If you've entered your password incorrectly too many times, your account
        may be locked out. This means that you won't be able to sign in and
        won't be able to do a self reset of your password.
      </UiKit.Text.BodyLarge>
      <UiKit.Text.BodyLarge>
        For security reasons, when your account gets locked, the error message
        on our page will not specify that your account is locked. Instead, it
        will continue to say that your email or password is incorrect. This is
        to prevent malicious users from purposefully locking your account.
      </UiKit.Text.BodyLarge>
      <UiKit.Text.BodyLarge>
        If you suspect your account is locked or you'd like someone to assist
        with a password reset, please contact support by using the Live Chat
        feature or calling directly at 1-800-367-1500.
      </UiKit.Text.BodyLarge>
      <UiKit.Text.BodyLarge>
        If you don't take any action, your account's lockout period should
        expire after
        <b>60 minutes</b> and you'll be able to sign in as usual.
      </UiKit.Text.BodyLarge>
    </UiKit.Chakra.VStack>),
    allowCollapse: true,
    initiallyCollapse: true,
});
const question6 = FormKit.BoxedSection({
    title: stringHackBolderTitle("Other questions or problems?"),
    Component: () => (<UiKit.Chakra.VStack spacing={UiKit.consistency.buffer} align={"left"}>
      <UiKit.Text.BodyLarge>
        For all other questions or issues, please use the Live Chat feature or
        call us directly at 1-800-367-1500. We are here to help!
      </UiKit.Text.BodyLarge>
    </UiKit.Chakra.VStack>),
    allowCollapse: true,
    initiallyCollapse: true,
});
const footerSection = FormKit.UnboxedSection({
    Component: () => <RecordHubPageFooter />,
});
export const FrequentlyAskedLoginQuestionSections = [
    titleSection,
    question1,
    question2,
    question3,
    question4,
    question5,
    question6,
    footerSection,
];
